import { Directive, ElementRef, HostListener, Input, AfterViewInit } from "@angular/core";

@Directive({
    selector: "[multiNumber]",
    standalone: false
})
export class MultiNumberDirective implements AfterViewInit {
  @Input("multiNumber") options: { isNumber: boolean; isDecimal: boolean; maxValue: number };

  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    // "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete",
  ];
  private regEx = undefined;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.options.isNumber) {
      this.regEx = /^([N]{1})([VB]{1})?$|^(0|[1-9]\d*)$/g;
    } else if (this.options.isDecimal) {
      // German locale: "," is the decimal separator (also for the 100 case).
      this.regEx = /^([N]{1})([VB]{1})?$|(^100([,]0{1,2})?)$|(^\d{1,2}([,]\d{0,3})?)$/g;
    }
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    this.validateRegEx(event);
  }

  private validateRegEx(event) {
    const el = this.el.nativeElement;
    const current: string = el.value;

    // Decimal inputs: treat a typed "." (or numpad Decimal) as the German decimal comma.
    if (this.options.isDecimal && (event.key === "." || event.key === "Decimal")) {
      event.preventDefault();
      const start: number = el.selectionStart ?? current.length;
      const end: number = el.selectionEnd ?? start;
      const next: string = current.slice(0, start) + "," + current.slice(end);
      if (String(next).match(this.regEx)) {
        el.value = next;
        try {
          el.setSelectionRange(start + 1, start + 1);
        } catch (e) {
          // setSelectionRange is unsupported on some input types; ignore.
        }
        el.dispatchEvent(new Event("input", { bubbles: true }));
      }
      return;
    }

    const next: string = current.concat(event.key);

    if (next && !String(next).match(this.regEx)) {
      event.preventDefault();
    } else {
      // There is a match, we need to check the maxValue in case of a number
      if (this.options.isNumber) {
        if (!isNaN(+next) && +next > this.options.maxValue) {
          event.preventDefault();
        }
      }
    }
  }
}
